import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Edit = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.0919 5.82837L24.9203 8.6568L13.3457 20.2315L10.5172 17.4031L22.0919 5.82837ZM9.10498 18.8192L8.38747 22.3612L11.9295 21.6437L9.10498 18.8192ZM20.6777 4.41415C21.4588 3.63311 22.7251 3.63311 23.5061 4.41416L26.3346 7.24258C27.1156 8.02363 27.1156 9.28996 26.3346 10.071L13.3486 23.0569C13.0706 23.335 12.7168 23.5249 12.3315 23.6029L7.30651 24.6208C6.60505 24.7629 5.98578 24.1437 6.12787 23.4422L7.1458 18.4172C7.22385 18.0319 7.41376 17.6781 7.69177 17.4001L20.6777 4.41415ZM4 27.9999C4 27.4477 4.44772 26.9999 5 26.9999H27C27.5523 26.9999 28 27.4477 28 27.9999C28 28.5522 27.5523 28.9999 27 28.9999H5C4.44772 28.9999 4 28.5522 4 27.9999Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Edit
